import React from 'react'
import LeftRight from '../left-right'
import { Button } from '@/components/ui/button'
import { PlusIcon } from 'lucide-react'
import StockPointCard from './card'
import { Route as dashboardRoute } from '@/routes/(inventory)/branch/_layout/dashboard/index'

const StockPointOverview = () => {
  const {stockPoinstInfo: data} = dashboardRoute.useLoaderData()
  return (
    <div className="mt-4">
      <div className="space-y-2">
        <LeftRight
          left="2 inventory requests"
          right={
            <Button size={'xs'} variant={'outline'} className="h-6 w-6 p-0">
              &gt;
            </Button>
          }
        />
        <LeftRight
          left="14 departments requesting for access to reports"
          right={
            <Button
              size={'xs'}
              className="bg-white border text-[#6F7B7C] text-sm font-semibold"
            >
              <PlusIcon className="text-black" />
              View Requests
            </Button>
          }
        />
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.stockPoints.map(point => (
          <StockPointCard key={point.id} stockPoint={point} />
        ))}
      </div>
    </div>
  )
}

export default StockPointOverview